import React, { Component } from "react";
import logo from "../Images/Logo.png";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import EmptyCartNavbar from "./AdditionalFeaturesDetails/EmptyCartNavbar";
import CartItems from "./CartItems";
import { removeFromCart, removeAll } from "./Store/Actions/EuropeActions";
import { asiaRemoveFromCart, asiaRemoveAll } from "./Store/Actions/AsiaActions";
import {
  americaRemoveFromCart,
  americaRemoveAll
} from "./Store/Actions/AmericaActions";
import classNames from "classnames";
import taxi from "../Images/peter-kasprzyk-111462-unsplash.jpg";
import tour from "../Images/janis-oppliger-178385-unsplash.jpg";
import hotel from "../Images/eunice-stahl-572017-unsplash.jpg";

class Navbar extends Component {
  constructor() {
    super();
    this.state = {
      menu: false,
      buyNoFeatures: false,
    };
  }
 

  render() {
    const europeInCart = this.props.europeData
      .map(item => (item.inCart ? item : "fail"))
      .filter(checkNull);
    const asiaInCart = this.props.asiaData
      .map(item => (item.inCart ? item : "fail"))
      .filter(checkNull);
    const americaInCart = this.props.americaData
      .map(item => (item.inCart ? item : "fail"))
      .filter(checkNull);
    function checkNull(arr) {
      return arr !== "fail";
    }
    let itemsInCart = europeInCart.concat(asiaInCart, americaInCart);
    let cartItemsDisplay = itemsInCart.map(item => (
      <CartItems
        key={item.id}
        item={item}
        removeFromCart={
          item.continent === "europe"
            ? this.props.removeFromCart
            : item.continent === "asia"
            ? this.props.asiaRemoveFromCart
            : this.props.americaRemoveFromCart
        }
      />
    ));
    let totalPriceAll =
      itemsInCart.length === 0
        ? 0
        : itemsInCart
            .map(item =>
              +item.total <= +item.totalWithOptions
                ? +item.totalWithOptions
                : +item.total
            )
            .reduce((a, b) => a + b);
    let itemsNoFeatures = itemsInCart
      .map(item => item)
      .filter(
        item =>
          item.totalWithOptions == 0 ||
          item.totalWithOptions == item.total ||
          item.totalWithOptions < item.total
      );

    let nameItemsNoFeatures = itemsNoFeatures.map((item, i, arr) =>
      arr.length - 1 === i ? item.title : item.title + ", "
    );

    this.showMenu = () => {
      this.setState(prevState => {
        return { menu: !prevState.menu };
      });
    };

    this.handleBuy = () => {
      if (itemsNoFeatures.length === 0) {
        this.props.removeAll();
        this.props.asiaRemoveAll();
        this.props.americaRemoveAll();
        this.setState({menu: false })
        alert("Thanks for using our services! We wish you happy holidays!");
      } else {
        this.setState({ buyNoFeatures: true });
      }
    };
    this.handleBuyAnyway = () => {
      this.props.removeAll();
      this.props.asiaRemoveAll();
      this.props.americaRemoveAll();
      this.setState({ buyNoFeatures: false, menu: false })
      alert("Thanks for using our services! We wish you happy holidays!");
    };

    this.closeFeaturesMenu = () => {
      this.setState({ buyNoFeatures: false, menu: false });
    };


    return (
      <React.Fragment>
        {console.log(totalPriceAll)}

        <nav className="navbar navbar-expand-sm sticky-top navbar-dark bg-light">
          <div className="navbar-brand">
            <Link to="/">
              <img src={logo} alt="logo" className="img-fluid logo" />
            </Link>
          </div>
          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon" />
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent"
       >
            <ul className="navbar-nav ml-3 mr-auto" data-toggle="collapse"
            data-target="#navbarSupportedContent">
              <li className="nav-item active " >
                <Link to="/" className="navbar-link p-4">
                  Start
                </Link>
              </li>
            </ul>
            <ul className="navbar-nav w-75 justify-content-around" data-toggle="collapse"
            data-target="#navbarSupportedContent">
              <li className="nav-item dropdown">
                <Link
                  to=""
                  className="nav-item dropdown-toggle navbar-link p-4"
                  id="navbarDropdown"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Tours
                </Link>
                <div
                  className="dropdown-menu"
                  aria-labelledby="navbarDropdown"
                  open={this.state.dropdownOpen}
                >
                  <Link className="dropdown-item" to="/america">
                    America
                  </Link>
                  <Link className="dropdown-item" to="/asia">
                    Asia
                  </Link>
                  <Link className="dropdown-item" to="/europe">
                    Europe
                  </Link>
                </div>
              </li>
              <li className="nav-item dropdown">
                <Link
                  className="nav-item dropdown-toggle navbar-link p-4"
                  id="navbarDropdown"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Additional services
                </Link>
                <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                  <Link
                    className="dropdown-item"
                    to="/additional-features/airport-pick-up"
                  >
                    Airport pick-up
                  </Link>
                  <Link
                    className="dropdown-item"
                    to="/additional-features/more-tours"
                  >
                    More tours
                  </Link>
                  <Link
                    className="dropdown-item"
                    to="/additional-features/hotels"
                  >
                    Hotels
                  </Link>
                </div>
              </li>
              <li className="nav-item">
                <Link to="/about-us" className="navbar-link p-4">
                  {" "}
                  About us
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/contact" className="navbar-link p-4">
                  Contact{" "}
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/blog" className="navbar-link p-4">
                  Blog{" "}
                </Link>
              </li>
            </ul>
            <i
              className="nav-item fas fa-shopping-cart ml-auto mr-3 p-4"
              onClick={() => this.showMenu()}
              data-toggle="collapse"
            data-target="#navbarSupportedContent"
            />
          </div>
        </nav>
        <div
          className={classNames(
            "cart-menu bg-light border-left border-top",
            this.state.menu ? "cart-show" : "cart-hidden"
          )}
        >
          <i className="fas fa-times" onClick={() => this.showMenu()} />
          <h2 className="text-center">Your cart</h2>
          {itemsInCart.length === 0 ? <EmptyCartNavbar /> : ""}
          <div className="row">
            {cartItemsDisplay}
            <div
              className={classNames(
                "col-12 text-center",
                totalPriceAll === 0 ? "hidden" : ""
              )}
            >
              <h6>Total price for all trips:</h6>
              <h6>${parseFloat(totalPriceAll).toFixed(2)}</h6>
              <button
                className="btn btn-success col-6"
                onClick={() => this.handleBuy()}
              >
                Buy now
              </button>
            </div>
          </div>
        </div>
        <div
          className={classNames(
            "center hidden",
            this.state.buyNoFeatures ? "show d-flex" : ""
          )}
        >
          <div className=" d-flex justify-content-md-center h-100 w-100">
            <div className="cube rounded border-secondary container ">
              <h4 className="text-center">
                It seems that you didn't picked any additional features for some
                of yours choosen trips
              </h4>
              <h5 className="text-center mt-3">
                Trips that doesn't have additional features:{" "}
                {nameItemsNoFeatures}
              </h5>
              <div className="mt-3 row">
                <div className="col-12 col-md-4">
                  {" "}
                  <img src={taxi} class="card-img-top" alt="Europe" />
                  <h6 class="card-title">Airport pick-up</h6>
                  <p className="card-text small h-25 text-justify">
                    Tell us when your's plane is arriving and we will pick you
                    up from the airport to your hotel
                  </p>
                  <div className="w-100 text-right">
                    <Link
                      to="/additional-features/airport-pick-up"
                      class="card-link"
                      onClick={() => this.closeFeaturesMenu()}
                    >
                      More info
                    </Link>
                  </div>
                </div>
                <div className="col-12 col-md-4">
                  {" "}
                  <img src={tour} class="card-img-top" alt="Europe" />
                  <h6 class="card-title">More tours</h6>
                  <p className="card-text small h-25 text-justify">
                    If you want to discover everything about a place where you
                    are going - pick up those additional premium tours!
                  </p>
                  <div className="w-100 text-right">
                    <Link
                      to="/additional-features/more-tours"
                      class="card-link"
                      onClick={() => this.closeFeaturesMenu()}
                    >
                      More info
                    </Link>
                  </div>
                </div>
                <div className="col-12 col-md-4">
                  {" "}
                  <img src={hotel} class="card-img-top" alt="Europe" />
                  <h6 class="card-title">Different hotel</h6>
                  <p className="card-text small h-25 text-justify">
                    If you want to stay in hotel that is closer to the sea or
                    mountain's just let us know!
                  </p>
                  <div className="w-100 text-right mb-2">
                    <Link
                      to="/additional-features/hotels"
                      class="card-link"
                      onClick={() => this.closeFeaturesMenu()}
                    >
                      More info
                    </Link>
                  </div>
                </div>
                <div className="col-12 d-flex justify-content-around">
                  <button
                    className="btn btn-primary"
                    onClick={() => this.closeFeaturesMenu()}
                  >
                    Continue shopping
                  </button>
                  <button
                    className="btn btn-success"
                    onClick={() => this.handleBuyAnyway()}
                  >
                    Buy anyway
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  europeData: state.europe,
  asiaData: state.asia,
  americaData: state.america
});

const mapDispatchToProps = dispatch => {
  return {
    removeFromCart: (id, data) => {
      dispatch(removeFromCart(id, data));
    },
    americaRemoveFromCart: (id, data) => {
      dispatch(americaRemoveFromCart(id, data));
    },
    asiaRemoveFromCart: (id, data) => {
      dispatch(asiaRemoveFromCart(id, data));
    },
    removeAll: () => {
      dispatch(removeAll());
    },
    asiaRemoveAll: () => {
      dispatch(asiaRemoveAll());
    },
    americaRemoveAll: () => {
      dispatch(americaRemoveAll());
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Navbar);
